export default __webpack_public_path__ + "static/media/icon_mobile_menu_pp.3b3cead6.svg";